import { useQuery } from '@tanstack/react-query';
import { useCan } from '@discovr/common';
import { SCOPES } from '@discovr/types';
import { discoveryApi } from '../api/discoveryApi';
import { discoveryKeys } from '../queryKeys';

/**
 * Loads the campaign through the sync call, so every Discovery visit pushes Go's current brief first. Refetched
 * on focus, so a run another tab or admin started shows up; not polled, since each refetch is a sync POST.
 * Sync needs discovery:write, so a read-only grant reads the stored campaign instead.
 */
export function useDiscoveryCampaign(campaignId: string) {
  const canWrite = useCan(SCOPES.discoveryWrite);
  return useQuery({
    queryKey: discoveryKeys.campaign(campaignId),
    queryFn: () => (canWrite ? discoveryApi.sync(campaignId) : discoveryApi.campaign(campaignId)),
    enabled: campaignId.length > 0,
    refetchOnWindowFocus: true,
  });
}
